import { render, staticRenderFns } from "./ApiMarketDetail.vue?vue&type=template&id=2e969daa&scoped=true"
import script from "./ApiMarketDetail.vue?vue&type=script&lang=js"
export * from "./ApiMarketDetail.vue?vue&type=script&lang=js"
import style0 from "./ApiMarketDetail.vue?vue&type=style&index=0&id=2e969daa&prod&lang=less"
import style1 from "./ApiMarketDetail.vue?vue&type=style&index=1&id=2e969daa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e969daa",
  null
  
)

export default component.exports